const formatFilterForView = (filters, view, entity) => (
    {
        [view]: {
            [entity]: filters,
        },
    }
);

export default formatFilterForView;
